import React, { useState } from "react";
import {
  Box,
  Button,
  IconButton,
  TextField,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

import "./PopupFilter.scss";

export const popupFilterMappings = {
  applicationBasedAnomalies: {
    userName: "userName",
    dataSource: "domainNames",
  },
  applicationBasedUsers: {
    userName: "userNames",
    dataSource: "domainNames",
    deviceName: "deviceNames",
  },
  cityBasedApplications: {
    userName: "userNames",
    dataSource: "domainNames",
    appName: "applicationNames",
  },
  locationBasedAnomalies: {
    userName: "userNames",
    dataSource: "domainNames",
    clientIp: "ipAddresses",
  },
  locationBasedUsers: {
    userName: "userNames",
    dataSource: "domainNames",
    clientIp: "ipAddresses",
  },
  userApplications: {
    deviceName: "deviceNames",
    appName: "applicationNames",
  },
  userAnomalies: {
    policyName: "policyNames",
  },
  userDevices: {
    deviceName: "deviceNames",
    deviceOs: "deviceOs",
  },
  userLocations: {
    location: "city",
    clientIp: "clientIp",
  },
};

const PopupFilter = ({ values, setValues, onApply, onCancel }) => {
  const [input, setInput] = useState("");

  const addValue = () => {
    const value = input.trim();

    if (!value) return;

    let newValues = values;

    if (!values.includes(value)) {
      newValues = [...values, value];
      setValues(newValues);
    }

    setInput("");

    return newValues;
  };

  const removeValue = (value) => {
    setValues(values.filter((item) => item !== value));
  };

  return (
    <Box className="popup-filter">
      <div className="popup-filter__header">
        <TextField
          fullWidth
          variant="outlined"
          size="small"
          placeholder="Type and press Enter"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              const updatedValues = addValue();
              if (updatedValues) {
                onApply(updatedValues);
              }
            }
          }}
        />
      </div>

      <div className="popup-filter__list">
        {values.map((value) => (
          <div className="popup-filter__item" key={value}>
            <Typography className="popup-filter__text" title={value}>
              {value}
            </Typography>

            <IconButton
              size="small"
              onClick={() => {
                removeValue(value);
                onApply(values.filter((item) => item !== value));
              }}
              className="popup-filter__close-btn"
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </div>
        ))}
      </div>

      <div className="popup-filter__footer">
        <Button className="popup-filter__cancel-btn" onClick={onCancel}>
          Cancel
        </Button>

        <Button
          variant="contained"
          className="popup-filter__apply-btn"
          onClick={() => onApply(values)}
        >
          Apply
        </Button>
      </div>
    </Box>
  );
};

export default PopupFilter;
